// extracted by mini-css-extract-plugin
export default {"container":"card_container__f0dbo","service-tab-para":"card_service-tab-para__hIAXM"};